import React from "react";
import { EditField } from "../types";
import { ThemeIconValue } from "../../../api/widgetThemeApi";
import { dispatchUploadIconRequest } from "../../../utils/editPanelEvents";
import colors from "../../../colors/colors";

const UPLOAD_NEW_VALUE = "__upload_new__";

interface IconFieldProps {
  value: string;
  onChange: (value: string) => void;
  field: EditField;
  themeIcons: Record<string, ThemeIconValue>;
}

export const IconField: React.FC<IconFieldProps> = ({
  value,
  onChange,
  themeIcons,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = e.target.value;
    if (selected === UPLOAD_NEW_VALUE) {
      dispatchUploadIconRequest();
      return;
    }
    onChange(selected);
  };

  return (
    <select
      value={value || "default"}
      onChange={handleChange}
      className="edit-panel-select"
      style={{
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${colors.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: colors.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: colors.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px",
      }}
    >
      <option value="default">Default</option>
      {Object.entries(themeIcons).map(([iconKey, iconValue]) => (
        <option key={iconKey} value={iconKey}>
          {iconValue.name}
        </option>
      ))}
      <option value={UPLOAD_NEW_VALUE}>Upload new...</option>
    </select>
  );
};

